module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“That’s a pretty little sloop,” Miss Nightingale called. “Rather different for these waters, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is, and I hope they’re not going to play loud music and interrupt your peaceful dinner,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, I shouldn’t think so, my dear, it doesn’t look the right boat for that sort of thing. It’s more of a proper sailor’s boat, if you know what I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I smiled at my favorite guest. Mollie Nightingale was a retired British schoolmarm, and by way of being my friend. Nothing had ever been said, but it was just there between us, that warm feeling, a kind of recognition I suppose you might call it. She had certain qualities I admired: integrity; an offbeat sense of humor; and a personal reticence that matched my own. Miss Nightingale kept her own counsel and I knew little about her private life; just the woman she was here at the Riviera. A woman I liked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had been my first guest, the week the Hotel Riviera opened for business, and she had been back every year since, coming late in the season when prices were lower and she could afford to stay for a month, before heading home to her cottage in the Cotswolds and her miniature Yorkie, Little Nell, and another long English winter. Meanwhile, she lived out her annual dream here, alone at a table for one, with a small carafe of local wine and book to hand, and always with a pleasant word and a smile for everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miss Nightingale was, I would guess, somewhere in her late seventies, short, square, and sturdy, and tonight she wore a pink flower-print dress. A white cardigan was thrown over her shoulders, though it was still warm out, and as always she had on her double row of pearls. Like the Queen of England, she always carried a large handbag, which, besides a clean linen handkerchief and her money, also contained her knitting. Now, I’m not sure if the Queen of England knits, but Miss Nightingale, with her determinedly gray hair set in stiff waves and curls, and her piercing blue eyes behind large pale spectacles, was a dead ringer for Her Majesty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was usually first down for dinner, showing up about this time for a glass of pastis, a little self-indulgence to which I knew she looked forward. She’d mix the anise liqueur with water in a tall glass then sip it slowly, making it last until dinner, which I also knew was the social highlight of her day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sat with her while she told me about her outing to the Villa Ephrussi, the old Rothschild house with its spectacular gardens up the coast near Cap-Ferrat. She always liked to tell me about the gardens she had discovered; she was a keen gardener herself and her own roses had won many local prizes. In fact, she was often to be found pottering about the gardens here, straw sunhat slammed firmly over her eyes, pulling up a naughty weed or two, or snipping back a recalcitrant branch of honeysuckle that threatened to overwhelm the already out-of-hand bougainvillea.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Settled at her usual table, the one at the end of the terrace nearest the kitchen, glass of pastis to hand, she gazed at the spectacular view and heaved a satisfied sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was that special time in the evening on the Côte d’Azur, when the sky seems to meld with the sea and all the world turns a shimmering silver-plated midnight-blue. In the sudden breathless silence that always comes when day turns into night, the chatter of high-pitched French voices floated from the kitchen, and a tiny lizard swished by, pausing to stare at us with jeweled yellow eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Divine,” Miss Nightingale murmured. “How you must love it here, my dear. How could you ever bear to leave it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without realizing it Miss Nightingale had struck right at the heart of my dilemma.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I do love it here. The trouble is I do not love my husband. All I feel for him right this minute is anger, because I believe that when Patrick left that morning he knew he was not coming back. He simply left me without a word, left me not knowing where he was, what had happened to him, or even if he were safe. If he’d run off with another woman, or decided just to wander the world the way he used to, at least he should have told me. And if he was in some kind of trouble, then he should have shared that with me too, and not just left me alone like this. Not knowing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Hotel Riviera is my home,” I said to Miss Nightingale. “It’s my own little piece of paradise. I’ll still be here when I’m an old, old lady, still looking after my guests, still cooking, still drinking rosé wine and not believing how blue the late evening sky can be just before night falls. Oh no, Miss Nightingale, I’ll never leave here, even if Patrick never…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If Patrick never comes back.” She eyed me sympathetically from behind her large glasses. “My dear, do you think he’s run off with another woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’d thought of that possibility so many times, lying in bed, tossing and turning, and I’d decided it was the only answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Miss Nightingale,” I said, genuinely lost, “what do I do now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s only one path for you to take, Lola, and that’s to move on with your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But how can I? Until I find out the truth?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She patted my hand, gently, the way she might an upset schoolgirl. I almost expected her to say, “There, there…,” but instead she said, “The answer to that, my dear, is you must find Patrick.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wanted to ask her how, where do I start? But my other guests were showing up for predinner drinks and a chat with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("patronne")]), _vm._v(", so I pulled myself together, dropped a kiss on her powder-scented cheek, and with a whispered “thanks for being so understanding,” went to greet them.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7ad92c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312308094_ch03.vue
// module id = 75
// module chunks = 0